function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.26 5.993c-2.57-3.008-6.922-2.866-9.846.057l-.707.707a1 1 0 0 1-1.414 0l-.707-.707c-2.919-2.918-7.398-3.063-9.832-.075C1.062 10.507 3.401 17.232 16 27.704 28.662 17.18 31.044 10.422 27.26 5.993zm1.521-1.3c4.766 5.58 1.82 13.644-12.148 25.08a1 1 0 0 1-1.267 0C1.47 18.396-1.419 10.386 3.204 4.713 6.439.74 12.294.929 16 4.636c3.705-3.705 9.408-3.89 12.781.058z"
});

var SvgFavorite = function SvgFavorite(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "13365ace016a1a3867964ac997178550.svg";
export { SvgFavorite as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/favorite.svg
// module id = null
// module chunks = 